import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface Sale {
  created_at: string;
  total_usd: number;
  commission_amount: number;
}

interface SalesChartProps {
  sales: Sale[];
}

export default function SalesChart({ sales }: SalesChartProps) {
  // Agrupar vendas por dia
  const groupedData = sales.reduce((acc: any, sale) => {
    const date = new Date(sale.created_at).toLocaleDateString('pt-BR');
    
    if (!acc[date]) {
      acc[date] = {
        date,
        revenue: 0,
        commission: 0,
        count: 0
      };
    }
    
    acc[date].revenue += parseFloat(sale.total_usd.toString());
    acc[date].commission += parseFloat(sale.commission_amount.toString());
    acc[date].count += 1;
    
    return acc;
  }, {});

  const chartData = Object.values(groupedData).sort((a: any, b: any) => {
    const dateA = new Date(a.date.split('/').reverse().join('-'));
    const dateB = new Date(b.date.split('/').reverse().join('-'));
    return dateA.getTime() - dateB.getTime();
  });

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        Nenhum dado disponível para exibir
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip 
          formatter={(value) =>
            typeof value === "number" ? `$${value.toFixed(2)}` : "$0.00"
          }
          labelFormatter={(label: string) => `Data: ${label}`}
        />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="revenue" 
          stroke="#10b981" 
          strokeWidth={2}
          name="Receita (USD)"
          dot={{ r: 4 }}
        />
        <Line 
          type="monotone" 
          dataKey="commission" 
          stroke="#8b5cf6" 
          strokeWidth={2}
          name="Comissão (USD)"
          dot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
